import QCXFinalFieldWrapper from '../../final-field/QCXFinalFieldWrapper';
import QCXTextField from '../../text-field/QCXTextField';
import type { AtributoCampoProps } from './types';

export default function ValorTextoV2({ atributo, basePath, disabled = false }: AtributoCampoProps) {
  const name = `${basePath}.${atributo.codigo}.valor`;
  const label = `${atributo.descricaoCodigo} (${atributo.codigo})`;

  return (
    <QCXFinalFieldWrapper
      name={name}
      label={label}
      component={QCXTextField}
      type="text"
      validate={undefined}
      format={undefined}
      parse={undefined}
      children={undefined}
      disabled={disabled}
      required
    />
  );
}
